const COMMENTS = [
  { name: '漫画迷小雨', avatar: '小', role: '韩漫爱好者', text: '终于找到一个分类这么清晰的漫画站了！纯爱分类简直是我的天堂，再也不用从一堆作品里大海捞针了。每天打开新新漫画看更新已经成了习惯～', time: '2 天前', likes: 128 },
  { name: '热血阿杰', avatar: '杰', role: '日漫铁粉', text: '日漫热血分类收录得太全了，连一些冷门佳作都能找到。更新速度也很快，追更体验满分！', time: '5 天前', likes: 96 },
  { name: '古风控小北', avatar: '北', role: '国漫支持者', text: '国漫古风区真的用心了，从画风到剧情筛选都很讲究，不是随便什么作品都往里塞。新新漫画对国产漫画的支持让人感动。', time: '1 周前', likes: 73 },
  { name: '深夜追漫人', avatar: '夜', role: '悬疑迷', text: '悬疑分类的推荐算法绝了，推给我的每一部都正中我心。而且没有广告打扰，一口气追到最新话，太爽了！', time: '3 天前', likes: 154 },
  { name: '轻松日常控', avatar: '乐', role: '搞笑漫画读者', text: '搞笑分类是我的快乐源泉！每天中午休息时刷两话，心情瞬间变好。分类做得特别细致，校园搞笑和日常搞笑还是分开的，很贴心。', time: '6 天前', likes: 89 },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          漫友热评
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          听听漫友们怎么说新新漫画
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS.map((comment) => (
            <div key={comment.name} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-[14px] flex-shrink-0">
                  {comment.avatar}
                </div>
                <div>
                  <h4 className="text-[14px] font-bold text-foreground-800">{comment.name}</h4>
                  <span className="text-[12px] text-foreground-400">{comment.role}</span>
                </div>
              </div>
              <p className="text-[14px] leading-relaxed text-foreground-600 mb-3">
                "{comment.text}"
              </p>
              <div className="flex items-center justify-between text-[12px] text-foreground-400">
                <span>{comment.time}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-heart-line"></i>
                  {comment.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}